import { Button, Text, TextInput } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../../api/client";
import { errorMessage } from "../../shared/session/errors";
import { FormError, Notice, Page } from "../../shared/ui/Page";

export function RecoverCodePage() {
  const { t } = useTranslation();
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [step, setStep] = useState<"phone" | "confirm" | "done">("phone");
  const [error, setError] = useState<string | null>(null);
  const start = async (e: React.FormEvent) => {
    e.preventDefault();
    const { response, error } = await api.POST("/auth/recover-code/start", { body: { phone } });
    if (response.ok) setStep("confirm");
    else setError(errorMessage(error, t("error.generic")));
  };
  const complete = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    const { response, error } = await api.POST("/auth/recover-code/complete", {
      body: { phone, otp, id_number: idNumber },
    });
    if (response.ok) setStep("done");
    else setError(errorMessage(error, t("error.generic")));
  };
  return (
    <Page title={t("recover.title")}>
      <Text size="sm">{t("recover.intro")}</Text>
      {step === "phone" && (
        <form onSubmit={start}>
          <TextInput
            label={t("recover.phone")}
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.currentTarget.value)}
            required
            mb="md"
          />
          <FormError message={error} />
          <Button type="submit" fullWidth mt="sm">
            {t("recover.send")}
          </Button>
        </form>
      )}
      {step === "confirm" && (
        <form onSubmit={complete}>
          <Notice>{t("recover.started")}</Notice>
          <TextInput
            label={t("recover.otp")}
            inputMode="numeric"
            autoComplete="one-time-code"
            value={otp}
            onChange={(e) => setOtp(e.currentTarget.value.trim())}
            required
            my="sm"
          />
          <TextInput
            label={t("recover.id_number")}
            inputMode="numeric"
            value={idNumber}
            onChange={(e) => setIdNumber(e.currentTarget.value)}
            required
            mb="md"
          />
          <FormError message={error} />
          <Button type="submit" fullWidth mt="sm">
            {t("recover.submit")}
          </Button>
        </form>
      )}
      {step === "done" && <Notice>{t("recover.done")}</Notice>}
    </Page>
  );
}
